//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Object.js";
import "../no/Diagramming.js";
import "../no/Session.js";
let d=[[],[[["sheet","targetPort","connection","connectionEndType"],"CreatePlcLogicBlockConnection",{},4,0],[["sheet","locationX","locationY","operandType"],"CreatePlcLogicBlockOperand",{R_:{nodeObject:"Diagramming.Node"}},4,0],[["selectedNode"],"AddPinToPlcLogicBlockOperator",{},1,0],[["selectedPort"],"NegatePlcLogicBlockPin",{},1,0],[["selectedPort"],"DeletePlcLogicBlockPin",{},1,0],[["selectedPorts"],"DeletePlcLogicBlockPins",{},1,0],[["selectedNode"],"GetDiagramSheetOfChartBlock",{R_:{sheet:"Diagramming.Sheet"}},1,0]],[]];
SPLM.AME.PlcChartManager = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.PlcChartManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;